import { axios } from '@/services/axios';

const updateUserProfile = async ({ formData, scope }) => {
    const res = await axios.put('/UserProfile', formData, {
        headers: {
            'X-RequestScope': scope,
        },
    });
    return res.data;
};

export default updateUserProfile;
